import { DISTRICTS_STATS } from '../../constants/districtsStats';
import { IFlatStats, TRooms } from '../../types/district';
import { ERooms } from '../../types/rooms';

function convertRooms(rooms: ERooms): TRooms {
  const map: { [key in ERooms]: TRooms } = {
    [ERooms.One]: '1',
    [ERooms.Two]: '2',
    [ERooms.Three]: '3',
    [ERooms.FourPlus]: '3', // максимально доступное количество комнат - 3
  };

  return map[rooms] || '1';
}

export function getDistrictFlatStats(district: string, rooms: ERooms): IFlatStats | null {
  const normalizedRooms = convertRooms(rooms);

  const roomsStats = DISTRICTS_STATS[district];
  if (!roomsStats) {
    return null;
  }

  const flatStats = roomsStats[normalizedRooms];
  if (!flatStats) {
    return null;
  }

  return flatStats;
}
